import React, { Reducer, useReducer, useEffect } from 'react';
import { ApplicationReducer } from './reducer/ApplicationReducer';
import { ApplicationContext } from './ApplicationContext';
import { ApplicationDispatchContext } from './ApplicationDispatchContext';
import { eApplicationActions } from './actions/eApplicationActions';
import { IApplicationActions } from './actions/IApplicationActions';
import { eSingleFields } from './state/eSingleFields';
import { IApplicationState } from './state/IApplicationState';
import { IOrderDetailsData } from '../../../ui-toolkit/orders/interfaces/IOrderDetailsData';

interface ICDBuilderApplicationProviderProps {
  order: IOrderDetailsData;
  children?: React.ReactNode;
}

export const CDBuilderApplicationProvider: React.FC<ICDBuilderApplicationProviderProps> = ({ children, order }) => {
  const [state, dispatch] = useReducer<Reducer<IApplicationState, IApplicationActions>>(ApplicationReducer, {
    isEditingSingleField: false,
    editingSingleFieldName: eSingleFields.estimated_property_value,
    order: order,
  });

  useEffect(() => {
    dispatch({ type: eApplicationActions.SetOrder, payload: order });
  }, [dispatch, order]);

  return (
    <ApplicationDispatchContext.Provider value={dispatch}>
      <ApplicationContext.Provider value={state}>{children}</ApplicationContext.Provider>
    </ApplicationDispatchContext.Provider>
  );
};
